import * as React from 'react';
import { styled } from 'styled-components';

import useFieldTypes from 'data-lake/hooks/useFieldTypes';
import useWidgetConfiguration from 'data-lake/preview/hooks/useWidgetConfiguration';
import useSelectedDataLake from 'data-lake/hooks/useSelectedDataLake';
import { Spinner, OverlayTrigger } from 'components/common';
import { Checkbox } from 'components/bootstrap';
import FieldTypeIcon from 'views/components/sidebar/fields/FieldTypeIcon';

const ListItem = styled.li`
  &:not(:last-child) {
    margin-bottom: 10px;
  }
`;

const StyledCheckbox = styled(Checkbox)`
  margin: 0;
`;

type Props = {
  tableId: string;
  isExpanded: boolean;
};

const TableFieldList = ({ tableId, isExpanded }: Props) => {
  const { filterableFields, isLoading } = useFieldTypes({ tableId }, isExpanded);
  const { widget, setWidget } = useWidgetConfiguration();
  const { dataLakeFieldsFetchQuery } = useSelectedDataLake();

  const isCurrentTable = dataLakeFieldsFetchQuery?.tableId === tableId;

  const onFieldSelect = (fieldName: string) => {
    const isSelected = widget.config.fields.includes(fieldName);
    const newFields = isSelected ? widget.config.fields.remove(fieldName) : widget.config.fields.add(fieldName);
    const newConfig = widget.config.toBuilder().fields(newFields).build();
    setWidget(widget.toBuilder().config(newConfig).build());
  };

  if (isLoading) {
    return <Spinner text="Loading fields..." />;
  }

  return (
    <ul style={{ padding: 0 }}>
      {filterableFields?.map((field) => (
        <ListItem key={field.name}>
          <OverlayTrigger
            trigger="hover"
            placement="bottom"
            disabled={isCurrentTable}
            overlay="You can only choose fields after setting this table as the active filter.">
            <div>
              <StyledCheckbox
                id="skip_tls_verification"
                name="skip_tls_verification"
                onChange={() => onFieldSelect(field.name)}
                disabled={!isCurrentTable}
                checked={isCurrentTable && widget.config.fields.includes(field.name)}>
                <FieldTypeIcon type={field.type} /> {field.name}
              </StyledCheckbox>
            </div>
          </OverlayTrigger>
        </ListItem>
      ))}
    </ul>
  );
};

export default TableFieldList;
